/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sound_Stock_Stork_QuizInputs */

const fr_sound_stock_stork_quiz = /** @type {(inputs: Sound_Stock_Stork_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

/**

* @param {Sound_Stock_Stork_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sound_stock_stork_quiz = /** @type {((inputs?: Sound_Stock_Stork_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sound_Stock_Stork_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sound_stock_stork_quiz(inputs)
});